import React from 'react';

const AddIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="20" height="20" rx="4" fill="black" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10 5.5C10.2761 5.5 10.5 5.72386 10.5 6V10H14.5C14.7761 10 15 10.2239 15 10.5C15 10.7761 14.7761 11 14.5 11H10.5V15C10.5 15.2761 10.2761 15.5 10 15.5C9.72386 15.5 9.5 15.2761 9.5 15V11H5.5C5.22386 11 5 10.7761 5 10.5C5 10.2239 5.22386 10 5.5 10H9.5V6C9.5 5.72386 9.72386 5.5 10 5.5Z" fill="white" />
  </svg>

);

export default AddIcon;
